import styled from 'styled-components';

import { CalendarWrapperCommon } from '@/pages/Common/Events/styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const CalendarWrapper = styled(CalendarWrapperCommon)`
  .fc-all-day-content {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.black1};
  }

  .fc-timegrid-axis-frame {
    justify-content: center;
  }
`;

export const MoreEventsWrapper = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  display: flex;
  padding: 2px 8px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  color: ${({ theme }) => theme.colors.black9};
  :hover {
    border-radius: 3px;
    background-color: ${({ theme }) => theme.colors.black2};
  }
`;
